export function getHttpStatus(error) {
  if (!error || !error.response) {
    return 0;
  }
  return Number(error.response.status) || 0;
}

export function extractBackendMessage(error) {
  const data =
    error && error.response && error.response.data
      ? error.response.data
      : null;
  const raw = data ? data.msg : "";
  if (!raw || typeof raw !== "string") {
    return "";
  }
  const text = raw
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .trim();
  if (!text) {
    return "";
  }
  const lower = text.toLowerCase();
  if (
    lower.indexOf("sql") !== -1 ||
    lower.indexOf("select ") !== -1 ||
    lower.indexOf("table ") !== -1 ||
    lower.indexOf("column") !== -1 ||
    lower.indexOf("panic") !== -1 ||
    lower.indexOf("goroutine") !== -1 ||
    lower.indexOf("stack trace") !== -1
  ) {
    return "";
  }
  return text;
}

export function getWaajoFormsErrorMessage(error, fallback) {
  const status = getHttpStatus(error);

  if (status === 401) {
    return "Sesi Anda telah berakhir. Silakan masuk kembali.";
  }
  if (status === 403) {
    return "Akses ke Form Builder tidak tersedia. Akun Anda mungkin sedang disuspend. Hubungi admin jika membutuhkan bantuan.";
  }
  if (status === 404) {
    return "Form tidak ditemukan atau sudah dihapus. Muat ulang daftar form.";
  }
  if (status === 406) {
    return extractBackendMessage(error) || fallback;
  }
  if (status === 413) {
    return "Data yang dikirim terlalu besar. Kurangi data lalu coba lagi.";
  }
  if (status >= 500) {
    return fallback;
  }
  if (!error || !error.response) {
    return "Tidak dapat terhubung ke server. Periksa koneksi internet Anda lalu coba lagi.";
  }
  return fallback;
}



// WEBPACK FOOTER //
// ./src/utils/waajoFormsError.js